import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

export default function EditDialog(props) {
    const { onSave, onClose, selectedValue, open } = props;

    const [loadingTime, setLoadingTime] = React.useState("");
    const [unLoadingTime, setUnLoadingTime] = React.useState("");
    const [waitTime, setWaitTime] = React.useState("");
    const [changeOverTime, setChangeOverTime] = React.useState("");

    React.useEffect(() => {
        console.log(selectedValue);
        if (selectedValue) {
            setLoadingTime(selectedValue.loading_time);
            setUnLoadingTime(selectedValue.unloading_time);
            setWaitTime(selectedValue.wait_time);
            setChangeOverTime(selectedValue.changeover_time);
        }
    }, [selectedValue])

    const handleClose = () => {
        onClose();
    };

    const handleSave = () => {
        onSave({
            loading_time: parseInt(loadingTime),
            unloading_time: parseInt(unLoadingTime),
            wait_time: parseInt(waitTime),
            changeover_time: parseInt(changeOverTime),
        });
    }

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>{`Configurations`}</DialogTitle>
            <Box
                // component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
                style={{ padding: '0 24px' }}
            >
                <div>
                    <TextField
                        id="loadingTime"
                        label="Loading Time"
                        type="number"
                        value={loadingTime}
                        onChange={(e) => setLoadingTime(e.target.value)}
                    />
                    <TextField
                        id="unloadingTime"
                        label="Unloading Time"
                        type="number"
                        value={unLoadingTime}
                        onChange={(e) => setUnLoadingTime(e.target.value)}
                    />
                    <TextField
                        id="waitTime"
                        label="Wait Time"
                        type="number"
                        value={waitTime}
                        onChange={(e) => setWaitTime(e.target.value)}
                    />
                    <TextField
                        id="changeOverTime"
                        label="ChangeOver Time"
                        type="number"
                        value={changeOverTime}
                        onChange={(e) => setChangeOverTime(e.target.value)}
                    />
                    <div style={{ margin: '10px', float: 'right' }}>
                        <button className="btn btn-primary success" style={{ marginRight: '10px' }} onClick={handleSave}>Save</button>
                        <button className="btn btn-primary success" onClick={() => handleClose()}>Cancel</button>
                    </div>
                </div>
            </Box>
        </Dialog>
    );
}
